import { Component, computed, effect, input, output } from '@angular/core';

import { UiToastType } from './ui-toast.types';

@Component({
  selector: 'ui-toast',
  standalone: true,
  templateUrl: './ui-toast.component.html',
  styleUrl: './ui-toast.component.scss'
})
export class UiToastComponent {
  readonly type = input<UiToastType>('info');
  readonly title = input('');
  readonly message = input('');
  readonly visible = input(false);
  readonly durationMs = input(3000);
  readonly dismiss = output<void>();

  constructor() {
    effect((onCleanup) => {
      if (!this.visible()) {
        return;
      }

      const timeout = setTimeout(() => {
        this.dismiss.emit();
      }, this.durationMs());

      onCleanup(() => clearTimeout(timeout));
    });
  }

  readonly iconPath = computed(() => {
    if (this.type() === 'success') {
      return 'M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm-1 14-4-4 1.4-1.4 2.6 2.6 5.6-5.6L18 9Z';
    }

    if (this.type() === 'warning') {
      return 'M12 3 1.8 20h20.4L12 3Zm1 13h-2v-2h2v2Zm0-4h-2V8h2v4Z';
    }

    if (this.type() === 'error') {
      return 'M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm4.2 13.8-1.4 1.4L12 13.4l-2.8 2.8-1.4-1.4L10.6 12 7.8 9.2l1.4-1.4L12 10.6l2.8-2.8 1.4 1.4L13.4 12Z';
    }

    return 'M11 7h2v2h-2zm0 4h2v6h-2zm1-9a10 10 0 1 0 10 10A10 10 0 0 0 12 2Z';
  });
}
